/**
 * El contrato que cumple todo tipo de pregunta (principio VII de la constitución).
 *
 * El motor de partida y el editor solo conocen esta interfaz: abrir, validar, puntuar. Nadie
 * pregunta de qué tipo es una pregunta para decidir cómo comportarse. `multiple_choice` es el
 * primer tipo, no el único previsto, y un motor con condicionales por tipo esparcidos por dentro
 * es un motor que habrá que reescribir para añadir verdadero/falso.
 *
 * En esta fase el contrato tiene **dos miembros**, no los cinco que enumera la constitución:
 * `isCorrect` y `score` no tienen nada que hacer hasta que exista el motor, en la fase 4. Se
 * añadirán entonces, a esta misma interfaz.
 */
/**
 * Los tipos de pregunta que existen.
 *
 * Añadir uno es añadir aquí su identificador y un módulo; si falta el módulo, el mapa de registro
 * no compila.
 */
export const QUESTION_TYPE_IDS = ['multiple_choice'];
export function isQuestionTypeId(candidate) {
    return QUESTION_TYPE_IDS.includes(candidate);
}
/**
 * Por qué una pregunta no se puede jugar.
 *
 * Viajan como clave de traducción, nunca como texto ya traducido: el idioma lo resuelve el
 * cliente (principio V).
 */
export const QUESTION_PROBLEM_REASONS = [
    'emptyPrompt',
    'tooFewOptions',
    'tooManyOptions',
    'emptyOption',
    'noCorrectOption',
    'severalCorrectOptions',
    'promptTooLong',
    'optionTooLong',
];
/**
 * Construye las dos vistas de un tipo a partir de una sola definición.
 *
 * El `safeParse` se escribe aquí una vez, y no en cada tipo: si la configuración no encaja
 * siquiera con el esquema, la pregunta no se puede jugar y el motivo es que le falta el
 * enunciado, que es lo que el editor sabe mostrar.
 */
export function defineQuestionType(definition) {
    return {
        ...definition,
        validateRaw(raw) {
            const parsed = definition.configSchema.safeParse(raw);
            if (!parsed.success)
                return [{ reason: 'emptyPrompt' }];
            return definition.validateQuestion(parsed.data);
        },
    };
}
//# sourceMappingURL=contract.js.map